<template>
  <div class="product-page">
    <!-- Banner Section -->
    <div class="banner-section">
      <div class="banner-container">
        <div class="banner-left">
          <img src="@/assets/product/LightBlue530.png"
               alt="Light 530"
               class="product-img" />
          <div class="product-name">{{ $t('product.lightbule530.name') }}</div>
        </div>
        <div class="banner-right">
          <h1 class="banner-title">{{ $t('product.lightbule530.bannerTitle') }}</h1>
          <div class="feature-list">
            <div class="feature-item"
                 v-for="(item, index) in bannerFeatures"
                 :key="index">
              <div class="feature-icon-wrapper">
                <img :src="item.icon"
                     alt="icon"
                     class="feature-icon" />
              </div>
              <div class="feature-text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Advantages Section -->
    <div class="advantages-section">
      <h2 class="section-title">{{ $t('product.lightbule530.sections.advantages') }}</h2>
      <div class="advantage-list">
        <div class="advantage-item"
             v-for="(item, index) in advantages"
             :key="index"
             :class="{ 'reverse': index % 2 !== 0 }">
          <!-- Text Area -->
          <div class="text-area">
            <div class="tag"
                 :style="{ backgroundColor: item.tagColor }">
              <img :src="item.tagIcon"
                   alt="icon"
                   class="tag-icon" />
              <span class="tag-title">{{ item.tagTitle }}</span>
            </div>
            <div class="desc">{{ item.desc }}</div>
          </div>

          <!-- Image Area -->
          <div class="image-area">
            <img :src="item.image"
                 :alt="item.tagTitle"
                 class="adv-img" />
          </div>
        </div>
      </div>
    </div>
    <!-- AI Banner Section -->
    <div class="ai-banner">
      <div class="ai-banner-content">
        <h2 class="ai-title">{{ $t('product.lightbule530.sections.aiTitle') }}</h2>
        <p class="ai-subtitle">{{ $t('product.lightbule530.sections.aiSubtitle') }}</p>
      </div>
    </div>

    <!-- Carousel Section -->
    <div class="carousel-section">
      <h2 class="carousel-title">{{ $t('product.lightbule530.sections.carouselTitle') }}</h2>
      <div class="carousel-container">
        <div class="carousel-track"
             :style="trackStyle">
          <!-- 原始列表 -->
          <div class="carousel-item"
               v-for="(item, index) in carouselItems"
               :key="'original-' + index">
            <img :src="item.image"
                 :alt="item.title"
                 class="carousel-img" />
          </div>
          <!-- 复制一份用于无缝循环 -->
          <div class="carousel-item"
               v-for="(item, index) in carouselItems"
               :key="'clone-' + index">
            <img :src="item.image"
                 :alt="item.title"
                 class="carousel-img" />
          </div>
        </div>
      </div>
    </div>

    <!-- Specs Section -->
    <div class="specs-section">
      <h2 class="section-title">{{ $t('product.lightbule530.sections.specsTitle') }}</h2>
      <div class="specs-container">
        <!-- 左列 -->
        <div class="specs-column">
          <div class="spec-row"
               v-for="(item, index) in leftSpecs"
               :key="index">
            <div class="spec-label">{{ item.label }}</div>
            <div class="spec-value">{{ item.value }}</div>
          </div>
        </div>

        <!-- 右列 -->
        <div class="specs-column">
          <div class="spec-row"
               v-for="(item, index) in rightSpecs"
               :key="'right-'+index">
            <div class="spec-label">{{ item.label }}</div>
            <div class="spec-value">{{ item.value }}</div>
          </div>
          <!-- 水冷系统 -->
        
          <div class="spec-row"
               v-for="(item, index) in waterCoolingSpecs"
               :key="'wc-'+index">
            <div class="spec-label">{{ item.label }}</div>
            <div class="spec-value">{{ item.value }}</div>
          </div>

          <!-- 气泵参数 -->
        
         
          <div class="spec-row"
               v-for="(item, index) in airPumpSpecs"
               :key="'ap-'+index">
            <div class="spec-label">{{ item.label }}</div>
            <div class="spec-value">{{ item.value }}</div>
          </div>

          <!-- 吸风系统 -->
        
          <div class="spec-row"
               v-for="(item, index) in exhaustSpecs"
               :key="'ex-'+index">
            <div class="spec-label">{{ item.label }}</div>
            <div class="spec-value">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const LIGHTBULE530_ADVANTAGE_MEDIA = [
  {
    tagIcon: require('@/assets/product/advicon.png'),
    tagColor: '#448EF7',
    image: require('@/assets/product/blueadv1.png'),
  },
  {
    tagIcon: require('@/assets/product/advicon.png'),
    tagColor: '#FBBC05',
    image: require('@/assets/product/blueadv2.png'),
  },
  {
    tagIcon: require('@/assets/product/advicon.png'),
    tagColor: '#8BC34A',
    image: require('@/assets/product/blueadv3.png'),
  }
]

const LIGHTBULE530_CAROUSEL_IMAGES = [
  require('@/assets/product/blue5301.png'),
  require('@/assets/product/blue5302.png'),
  require('@/assets/product/blue5303.png'),
  require('@/assets/product/blue5304.png'),
  require('@/assets/product/blue5305.png'),
  require('@/assets/product/blue5306.png'),
  require('@/assets/product/blue5307.png'),
  require('@/assets/product/blue5308.png'),


]

export default {
  name: 'ProductLight530',
  data() {
    return {
      scrollPosition: 0,
      scrollSpeed: 1, // 滚动速度，像素/帧
      animationFrameId: null
    }
  },
  computed: {
    lightbule530Copy() {
      const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'zh-CN'
      const messages = this.$i18n && this.$i18n.getLocaleMessage ? this.$i18n.getLocaleMessage(locale) : {}
      return (messages.product && messages.product.lightbule530) || {}
    },
    leftSpecs() {
      return this.lightbule530Copy.specs && this.lightbule530Copy.specs.left ? this.lightbule530Copy.specs.left : []
    },
    rightSpecs() {
      return this.lightbule530Copy.specs && this.lightbule530Copy.specs.right ? this.lightbule530Copy.specs.right : []
    },
    waterCoolingSpecs() {
      return this.lightbule530Copy.specs && this.lightbule530Copy.specs.water ? this.lightbule530Copy.specs.water : []
    },
    airPumpSpecs() {
      return this.lightbule530Copy.specs && this.lightbule530Copy.specs.air ? this.lightbule530Copy.specs.air : []
    },
    exhaustSpecs() {
      return this.lightbule530Copy.specs && this.lightbule530Copy.specs.exhaust ? this.lightbule530Copy.specs.exhaust : []
    },
    bannerFeatures() {
      const texts = this.lightbule530Copy.bannerFeatures || []
      return texts.map((text) => ({
        icon: require('@/assets/product/icon.png'),
        text
      }))
    },
    advantages() {
      const items = this.lightbule530Copy.advantages || []
      return items.map((item, index) => ({
        tagTitle: item.tagTitle,
        tagIcon: LIGHTBULE530_ADVANTAGE_MEDIA[index] ? LIGHTBULE530_ADVANTAGE_MEDIA[index].tagIcon : '',
        tagColor: LIGHTBULE530_ADVANTAGE_MEDIA[index] ? LIGHTBULE530_ADVANTAGE_MEDIA[index].tagColor : '#448EF7',
        desc: item.desc,
        image: LIGHTBULE530_ADVANTAGE_MEDIA[index] ? LIGHTBULE530_ADVANTAGE_MEDIA[index].image : ''
      }))
    },
    carouselItems() {
      const titles = this.lightbule530Copy.carouselTitles || []
      return LIGHTBULE530_CAROUSEL_IMAGES.map((image, index) => ({
        title: titles[index] || `Item ${index + 1}`,
        image
      }))
    },
    trackStyle() {
      return {
        transform: `translateX(-${this.scrollPosition}px)`
      }
    }
  },
  mounted() {
    this.startCarousel()
  },
  beforeDestroy() {
    this.stopCarousel()
  },
  methods: {
    startCarousel() {
      const animate = () => {
        this.scrollPosition += this.scrollSpeed

        // 假设每个item宽316 + 间距20 = 336px (这里需要根据CSS实际值调整)
        // 这里的 336 是 (316 + 20) 的估算值，实际在CSS中设置
        const itemWidth = 336
        const totalWidth = this.carouselItems.length * itemWidth

        // 当滚动到一半（原始列表结束）时，重置回起点，实现无缝
        if (this.scrollPosition >= totalWidth) {
          this.scrollPosition = 0
        }

        this.animationFrameId = requestAnimationFrame(animate)
      }
      this.animationFrameId = requestAnimationFrame(animate)
    },
    stopCarousel() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId)
      }
    }
  }
}
</script>

<style scoped>
/* ... existing styles ... */

/* AI Banner Section */
.ai-banner {
  width: 100%;
  height: 600px;
  background-image: url("@/assets/product/aibanner.png"); /* AI Tech bg */
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-banner-content {
  width: 1200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: -100px; /* 根据图示大概位置调整 */
}

.ai-title {
  font-size: 34px;
  color: #333;
  margin-bottom: -20px;
  font-weight: normal; /* 图示看起来不是特别粗，或者根据需要调整 */
}

.ai-subtitle {
  font-size:34px;
  color: #333;
  font-weight: normal;
}

/* Carousel Section */
.carousel-section {
  width: 100%;
  height: 650px;
  background-color: #f4f6fa;
  padding-top: 80px;
  overflow: hidden; /* 隐藏超出部分 */
}

.carousel-title {
  font-size: 34px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 60px;
}

.carousel-container {
  width: 100%;
  /* 不需要限制1200px，因为是全屏流式轮播 */
  overflow: hidden;
}

.carousel-track {
  display: flex;
  gap: 20px; /* 间距 */
  width: max-content; /* 让宽度自适应内容 */
  padding-left: 50px; /* 初始偏移一点，避免贴边 */
  will-change: transform; /* 优化性能 */
}

.carousel-item {
  width: 316px;
  height: 316px;
  flex-shrink: 0;
  border-radius: 30px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-page {
  width: 100%;
  background-color: #fff;
  padding-bottom: 80px; /* 增加底部留白 */
}

/* Specs Section */
.specs-section {
  width: 1200px;
  margin: 0 auto;
  padding-top: 100px;
  padding-bottom: 50px;
}

.specs-container {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.specs-column {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.spec-row {
  display: flex;
  min-height: 50px; /* 确保行高 */
}

/* 隔行变色逻辑需要小心，因为这里是手动分组
   我们可以用 :nth-child 来做简单的条纹，
   或者给每一行单独的样式。UI图看起来是交替的灰色背景。
*/
.spec-row:nth-child(odd),
.spec-value-only:nth-child(odd),
.spec-full-row:nth-child(odd) {
  background-color: #f9f9f9; /* 浅灰 */
}

/* 左侧列统一样式 */
.specs-column:first-child .spec-row:nth-child(odd) {
  background-color: #f9f9f9;
}
.specs-column:first-child .spec-row:nth-child(even) {
  background-color: #fff;
}

/* 右侧列比较复杂，有标题穿插，建议统一给所有直接子元素加条纹 */
.specs-column > div {
  /* 默认白色 */
  background-color: #fff;
}
/* 
  但是右侧有标题行，标题行是灰色的。
  根据图示，标题行(group-header)通常有背景色 #EAEAEA
*/

.spec-group-header {
  background-color: #e6e6e6;
  font-weight: bold;
  color: #333;
  padding: 15px 20px;
  font-size: 16px;
  margin-bottom: 0; /* 紧贴下方内容 */
}

.spec-label {
  width: 180px; /* 标签宽度 */
  padding: 15px 20px;
  color: #333;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.spec-value {
  flex: 1;
  padding: 15px 20px;
  color: #666;
  display: flex;
  align-items: center;
  line-height: 1.5;
}

.spec-value-only {
  padding: 15px 20px;
  color: #666;
  background-color: #fff; /* 或根据条纹 */
}

.spec-full-row {
  padding: 15px 20px;
  color: #666;
  background-color: #f9f9f9; /* 最后一行如果是单行，可能是灰色 */
}

/* 针对左列的条纹调整：第一行是白色还是灰色？通常第一行白色 */
.specs-column:first-child .spec-row:nth-of-type(odd) {
  background-color: #f9f9f9;
}
.specs-column:first-child .spec-row:nth-of-type(even) {
  background-color: #fff;
}

/* 右列条纹：
   需要手动控制或者用复杂的 nth-child。
   为了简单还原UI图，我们假设右侧每个小块内部也是交替的。
   但右侧有 Header 隔断。
   
   简单策略：
   Header: #E6E6E6
   内容行: 交替 #fff / #f9f9f9
*/
.specs-column:last-child .spec-row:nth-of-type(odd) {
  background-color: #fff;
}
.specs-column:last-child .spec-row:nth-of-type(even) {
  background-color: #f9f9f9;
}
/* 特殊处理：气泵下方的纯值行 */
.spec-value-only {
  background-color: #fff;
}

/* Banner Section */
.banner-section {
  width: 100%;
  height: 684px;
  background-image: url("@/assets/product/bluebanner.png"); /* Tech bg */
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-container {
  width: 1200px;
  height: 406px;
  display: flex;
  background: rgba(255, 255, 255, 0.21);
  border-radius: 10px;
 
}

.banner-left {
  width: 532px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-img {
  width: 532px;
  height: 352px;
  object-fit: contain;
}

.product-name {
  margin-top: 20px; /* Adjust as needed, user didn't specify gap but said below */
  font-size: 20px;
  color: #333;
  text-align: center;
}

.banner-right {
  flex: 1;
  padding-left: 50px; /* Adjust spacing */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.banner-title {
  font-size: 40px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px; /* Adjust spacing */
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.feature-item {
  display: flex;
  align-items: center;
}

.feature-icon-wrapper {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}

.feature-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(
    0 2px 4px rgba(68, 142, 247, 0.3)
  ); /* Add blue tint hint if possible or use colored icon */
}

.feature-text {
  font-size: 20px;
  color: #333;
}

/* Advantages Section */
.advantages-section {
  width: 1200px;
  margin: 0 auto;
  padding-top: 80px;
  padding-bottom: 100px;
}

.section-title {
  font-size: 34px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 80px;
}

.advantage-list {
  display: flex;
  flex-direction: column;
  gap: 100px; /* Large gap between items */
}

.advantage-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.advantage-item.reverse {
  flex-direction: row-reverse;
}

.text-area {
  width: 453px;
  height: 206px;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* To align tag top and desc bottom if needed, or just flow */
}

.tag {
  width: 283px;
  height: 62px;
  border-radius: 65px;
  display: flex;
  align-items: center;
  padding: 0 20px; /* Adjust padding */
  box-sizing: border-box;
}

.tag-icon {
  width: 42px;
  height: 42px;
  margin-right: 15px;
  object-fit: contain;
  filter: brightness(0) invert(1); /* Make white */
}

.tag-title {
  font-size: 20px;
  color: #fff;
  font-weight: bold;
}

.desc {
  width: 453px;
  height: 120px; /* Fixed height as requested */
  font-size: 16px;
  color: #333;
  line-height: 1.6;
  margin-top: auto; /* Push to bottom of container if using flex column with height */
}

.image-area {
  width: 577px;
  height: 360px;
  border-radius: 20px; /* Optional rounded corners for images */
  overflow: hidden;
}

.adv-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
